import registerBarValueLabel from './BarValueLabel'
import registerScrollableLegend from './ScrollableLegend'
import registerTooltip from './TooltipPlugin'

export default (F2) => {
  if (F2.__register_customer_plugin__)  {
    return
  }
  
  registerBarValueLabel(F2)
  registerScrollableLegend(F2)
  registerTooltip(F2)
  
  F2.__register_customer_plugin__ = true
}
